import { APIRequest } from "../lib/_sso";
import AppConfig from "../_appConfig";

const server = AppConfig.api_server;

export default {
  getWeek: (id, year, week) => APIRequest.get(`${server}/members/${id}/schedule/week/${year}/${week}`).then(res => res.data),
  getMonth: (id, year, month) => APIRequest.get(`${server}/members/${id}/schedule/month/${year}/${month}`).then(res => res.data),
  bulkUpdate: (id, data) => APIRequest.post(`${server}/members/${id}/schedule/bulk`, data).then(res => res.data),
}